import { Button } from "react-bootstrap";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { MobileAppFirstStartButtonsContainerStyled, MobileAppFirstStartContentStyled } from "./styled/MobileAppFirstStartStyled";
import { useCallback } from "react";
import appHistory from "../../../app/appHistory";
import { MobileRouterPaths } from "../../mobileAppConstants";

function MobileAppFirstStart() {
    const {getLangPath} = useLangContext();

    const handleSignUpClick = useCallback(() => {
        appHistory.push(MobileRouterPaths.registration);
    }, []);

    const handleAlreadyUserClick = useCallback(() => {
        appHistory.push(MobileRouterPaths.login);
    }, []);

    return <div className="d-flex justify-content-center align-items-center h-100">
        <MobileAppFirstStartContentStyled>
            <img src={`${process.env.PUBLIC_URL}/assets/auth/start.png`} alt="start" className="w-100"/>
            <MobileAppFirstStartButtonsContainerStyled>
                <Button variant="primary" size="lg" onClick={handleSignUpClick}>
                    {getLangPath('sign_up.title')}
                </Button>
                <Button variant="outline-info" size="lg" className="mt-3" onClick={handleAlreadyUserClick}>
                    {getLangPath('promo.fx.start.already_user')}
                </Button>
            </MobileAppFirstStartButtonsContainerStyled>
        </MobileAppFirstStartContentStyled>
    </div>
}

export default MobileAppFirstStart;
